import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-1">
            <span className="text-lg font-heading font-bold text-foreground-950">
              Kakobuy<span className="text-primary-500">Spreadsheet</span>
            </span>
            <p className="text-sm text-foreground-600">Najlepszy polski przewodnik zakupowy</p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
            <Link to="/" className="text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Strona główna
            </Link>
            <Link to="/artykul/kakobuy-spreadsheet" className="text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Poradnik
            </Link>
            <Link to="/artykul/sneakersy-kakobuy" className="text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Sneakersy
            </Link>
            <Link to="/artykul/bezpieczenstwo-kakobuy" className="text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Bezpieczeństwo
            </Link>
            <Link to="/#categories" className="text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Kategorie
            </Link>
            <Link to="/#faq" className="text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              FAQ
            </Link>
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
          </a>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/60">
          <p className="text-xs text-foreground-500 text-center leading-relaxed">
            Ta strona jest niezależnym przewodnikiem i nie jest powiązana z Kakobuy. Wszystkie znaki towarowe należą do ich właścicieli.
            Linki zewnętrzne prowadzą do stron trzecich. © 2026 Kakobuy Spreadsheet Polska.
          </p>
        </div>
      </div>
    </footer>
  );
}